import {Component} from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash'

import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthUrls } from './constants/auth';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'map labs';

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (document.location.href.includes('export-invoice-pdf')) {
      // Used to support the original link sent by billing-api with the following format:
      // https://ml-master-admin.web.app/export-invoice-pdf/export-invoice-pdf/<INV_ID>/<GID>"
      const [inv_id, gid] = document.location.href.split('/').slice(-2);
      this.router.navigate([`/export-invoice-pdf/${inv_id}/${gid}`]);
    } else {
      this.router.navigate([AuthUrls.LOGIN])
    }
  }
}

